import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/me/credentials")({
  // Keep the rest of the query and the hash, like the other legacy redirects.
  beforeLoad: ({ location }) => {
    const params = new URLSearchParams(location.searchStr);
    params.set("tab", "credentials");
    throw redirect({
      href: `/app/me/settings?${params}${location.hash ? `#${location.hash}` : ""}`,
      replace: true,
    });
  },
});
